const HoldingDispositionResultEnum = Object.freeze({
    NONE: 'NONE',
    SOLD: 'SOLD',
    EXIT: 'EXIT',
    FAIL: 'FAIL'
});

export default HoldingDispositionResultEnum;
